// src/pages/ContactPage.jsx
import React from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaBuilding } from "react-icons/fa";
import bigmartImg from "../assets/BIGMART.jpeg";

const ContactPage = () => {
  return (
    <div style={containerStyle}>
      {/* Breadcrumb */}
      <div style={breadcrumbStyle}>
        Home &gt; <span style={{ color: "#FFA500" }}>Contact</span>
      </div>

      {/* Top Info Cards */}
      <div style={topCardsContainer}>
        <InfoCard
          icon={<FaBuilding size={30} color="#FFA500" />}
          title="GTO Hypermarket"
          description="Al Jurf Industrial 1, Ajman, UAE"
        />
        <InfoCard
          icon={<FaPhoneAlt size={30} color="#FFA500" />}
          title="Phone"
          description="+971 54 266 0433"
        />
        <InfoCard
          icon={<FaEnvelope size={30} color="#FFA500" />}
          title="Email"
          description="customerservice@bccmart.ae"
        />
      </div>

      {/* Main Section */}
      <div style={mainSection}>
        {/* Left Section */}
        <div style={leftSection}>
          <h2 style={sectionTitle}>
            <strong>GTO</strong> Hypermarket
          </h2>

          <img src={bigmartImg} alt="Big Mart" style={imageStyle} />

          <ContactCard
            icon={<FaMapMarkerAlt color="#FFA500" />}
            label="Address"
            value="Al Jurf Industrial 1, Ajman, UAE"
          />
          <ContactCard
            icon={<FaPhoneAlt color="#28a745" />}
            label="Phone"
            value="+971 54 266 0433"
          />
          <ContactCard
            icon={<FaEnvelope color="#28a745" />}
            label="Email"
            value="admin@bccmart.ae"
          />

          <h2 style={{ ...sectionTitle, marginTop: "30px" }}>
            <strong>Leasing</strong> Department
          </h2>
          <ContactCard
            icon={<FaMapMarkerAlt color="#FFA500" />}
            label="Address"
            value="Al Jurf Industrial 1, Ajman, UAE"
          />
          <ContactCard
            icon={<FaPhoneAlt color="#28a745" />}
            label="Phone"
            value="+971 54 266 0433"
          />
          <ContactCard
            icon={<FaEnvelope color="#28a745" />}
            label="Email"
            value="admin@bccmart.ae"
          />
        </div>

        {/* Right Section */}
        <div style={rightSection}>
          <h2 style={sectionTitle}>
            <strong>Reach</strong> Us
          </h2>
          <form style={formStyle} onSubmit={(e) => e.preventDefault()}>
            <input type="text" placeholder="Your Name" style={inputStyle} />
            <input type="email" placeholder="Your Email" style={inputStyle} />
            <input type="text" placeholder="Subject" style={inputStyle} />
            <textarea
              placeholder="Message"
              style={{ ...inputStyle, height: "120px" }}
            />
            <button type="submit" style={buttonStyle}>
              Send Message
            </button>
          </form>
        </div>
      </div>

      {/* Map */}
      <div style={{ marginTop: "50px" }}>
        <h2 style={sectionTitle}>Our Location</h2>
        <iframe
          title="Big Mart Location"
          src="https://www.google.com/maps?q=25.43012,55.5343568&hl=en&z=16&output=embed"
          width="100%"
          height="400"
          style={{ border: 0, borderRadius: "12px" }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>

        <div style={{ marginTop: "15px", textAlign: "center" }}>
          <a
            href="https://www.google.com/maps/dir/25.4380785,55.5458432/Big+mart,+AL+JURF+-+Al+Jerf+Industrial+1+-+Ajman/"
            target="_blank"
            rel="noopener noreferrer"
            style={directionBtn}
          >
            Get Directions
          </a>
        </div>
      </div>
    </div>
  );
};

// Components
const InfoCard = ({ icon, title, description }) => (
  <div style={infoCardStyle}>
    <div style={{ marginRight: "15px" }}>{icon}</div>
    <div>
      <h4 style={{ margin: 0 }}>{title}</h4>
      <p style={{ margin: 0, color: "#555" }}>{description}</p>
    </div>
  </div>
);

const ContactCard = ({ icon, label, value }) => (
  <div style={contactCardStyle}>
    <div style={{ marginRight: "15px" }}>{icon}</div>
    <div>
      <p style={{ margin: 0, fontWeight: "bold" }}>{label}:</p>
      <p style={{ margin: 0 }}>{value}</p>
    </div>
  </div>
);

// Styles
const containerStyle = {
  fontFamily: "Arial",
  padding: "20px",
  backgroundColor: "#f9f9f9",
};

const breadcrumbStyle = {
  marginBottom: "20px",
};

const topCardsContainer = {
  display: "flex",
  gap: "20px",
  marginBottom: "40px",
  flexWrap: "wrap",
};

const infoCardStyle = {
  flex: 1,
  background: "#fff",
  padding: "20px",
  borderRadius: "12px",
  display: "flex",
  alignItems: "center",
  minWidth: "200px",
};

const mainSection = {
  display: "flex",
  gap: "50px",
  flexWrap: "wrap",
};

const leftSection = {
  flex: 1,
  minWidth: "300px",
};

const rightSection = {
  flex: 1,
  minWidth: "300px",
};

const sectionTitle = {
  marginBottom: "20px",
};

const contactCardStyle = {
  display: "flex",
  alignItems: "center",
  background: "#fff",
  padding: "15px",
  borderRadius: "10px",
  marginBottom: "15px",
};

const formStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "15px",
};

const inputStyle = {
  padding: "10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
};

const buttonStyle = {
  padding: "12px",
  backgroundColor: "#FFA500",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
};

const directionBtn = {
  padding: "10px 20px",
  backgroundColor: "#FFA500",
  color: "#fff",
  borderRadius: "6px",
  textDecoration: "none",
};

const imageStyle = {
  width: "100%",
  borderRadius: "12px",
  marginBottom: "20px",
};

export default ContactPage;